<template>
  <div>
    <div class="flex justify-content-between align-items-center">
      <h1 class="capitalize">{{ t('title') }}</h1>
      <Button
        icon="pi pi-arrow-right"
        iconPos="right"
        :label="t('skipToMapper')"
        @click="router.push(`/dashboard/quotations/${route.params.id}/import/mapper`)"
        outlined
      />
    </div>
    <div class="card">
      <ExcelImport
        :uploadFile="uploadFile"
        :importFile="importFromFile"
        :updateFileOptions="updateFileOptions"
        uploadMode="advanced"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useUploader } from '@/domains/quotations/mapper/composables/useUploader'
import ExcelImport from '@/domains/quotations/ExcelImport.vue'
import { useImportTable } from '@/domains/quotations/mapper/composables/useImportTable'
import { useRouter, useRoute } from 'vue-router'

const { t } = useI18n()
const router = useRouter()
const route = useRoute<'/dashboard/quotations/[id]/import'>()

definePage({
  props: true
})
const { id } = defineProps<{
  id: string
}>()
const { uploadFile, updateFileOptions } = useUploader(id)
const { importFromFile } = useImportTable(id)
</script>

<i18n lang="yaml">
en:
  title: 'import'
  skipToMapper: 'skip to mapper'
nl:
  title: 'import'
  skipToMapper: 'overslaan naar mapper'
de:
  title: 'import'
  skipToMapper: 'zum mapper springen'
</i18n>
